import React from "react";

const NotificationContext = React.createContext([]);
NotificationContext.displayName = 'Notification context';

export default NotificationContext;